export default function cleanupLegacyServiceWorker(windowObj: Window) {
    const serviceWorker: ServiceWorkerContainer = windowObj.navigator.serviceWorker;
    if (serviceWorker != null && serviceWorker.controller != null) {
        serviceWorker.getRegistrations().then((registrations: ServiceWorkerRegistration[]) => {
            const origin: string = windowObj.location.origin + '/';
            for (let i = 0; i < registrations.length; ++i) {
                // Cleanup registration done from owa
                if (origin.toLowerCase() == registrations[i].scope.toLowerCase()) {
                    registrations[i].unregister();
                }
            }
        });
    }
}
